
















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class EventsPerPerson extends Vue {
  @Prop()
  events: { name: string; alias: string; username?: string }[];

  @Prop()
  totalEvents: { name: string; alias: string }[];
}
